import React from 'react'
import Sketch from 'react-p5'
import LocalizedStrings from 'react-localization';
import {LanguageContext} from "./LanguageContext"

const extensions = require("./extensions")

let strings = new LocalizedStrings({
    en:{
        title:"spiral",
        description:""
    },
    de: {
        title:"spirale",
        description:""
    }
});

class Spiral extends React.Component {
    constructor(props) {
        super(props)
        this.charsDE = "weiterinneentlangdrüberemporrunterentlangniedertlosannachgradinnenebenhernebenhereinherteinnebenhertrunteraufursinnenebenherniederentzweinebenherentzweibeisammenerniederhineinerrumnebenherinneerdurchentrunterentnebenhertlosausniedergraddreinabvoraufonebenheraufunsraufeininneniederentgegennebenhertmitinnetprumübereinbevorentzweirüberüberbeieinrunterbeeininnesanmitmitentgegennebenherentlanginnenebenherhinabeinherrunterrumausumherforteinherrumnebenheraufchinuntertzurechtumhinwiderergeernachtgrademporgradeempornebenherinnenebenherniederentnacheinherbeisammenerniederhintenherumeinherranausbeisammencherunterinnenachwiderentlanggegenübertzuentzweiraufumnachtentlangrumweiterinneerdazwischeneinrunterinnenachniederempordurchabranniederinneeindarniederentgegenrumeininneniederhereinentlangraufrumentinneniederweiterinneempdranentzweirübereinherniedertlosaufnebenhergegengeraderanaufdawidereinherentgegeninneniederinnenachnebenherentnachentzweibeientzweinachheranemporrumhinunterinneniedertausnebenherernebenhertraufabnebenherinnenebenhernebenhereinnebenherabchinunternachinneempordahinemprumentgegenmitporaufgraderaufausdranerentgegeninneniederhintenüberentgegenrüberrübereinherinnenachaufunsdagegenanzuvorureininneniederreinübereinbevoreinrumumhinnachteinrummitinnetaufnachnebenherentlangbeientgegenniederheraufentgegenreindreinreinausniederanumherszuvorweginneschinunterentgegennebenherurmitorumabumhinfortentgegenmitpinnenebenherniederempniederinneeindareinherrausemporinnenachherzuemprummitinnetpinnenebenhernebenherentgegennachentbeisammenempnebenherhinüberentlangreinniedererbeisammeneinnachherzuemporraufeinnachtlosausnebenhergegenübernachinneentgegendarniederemporruminnenebenhernebenherentzweierinneniederdurchaufrunterumhinmitentgegenrunterreineininneniederannachuntermitheraninneniedersniederinneentzweidraufentgegenraneinmitbeemporeinhernachtlosabnebenhergeradeniedereinherbeernebenherhineinempranherzuerrunterbeentzweiinneentniedertreinabunsumniedermitinnethereininnenachübereinbevorentreineininnenachherentgegenranranübereinbeentlangranmitinnetinnenebenhernachemportherunterinnenebenherunternebenhertemprübererniedertgegenentgegengradentnebenherreinabursübereinbeisammenentreinbeempinnesabmitmitempnachempnebenhertlosausniedergradreinüberbevoreinherrauseininnenebenhermitinnetprumunnebenherterrananunfortunmitfortoruntert"
        this.charsEN = ""
        this.chars = ""
        this.englishPrefixes = ["anti", "auto", "de", "dis", "down", "extra", "hyper", "il", "im", "in", "ir", "inter", "mega", "mid", "mis", "non", "over", "out", "post", "pre", "pro", "re", "semi", "sub", "super", "tele", "trans", "ultra", "un", "under", "up"]

        this.fwd = 1

        this.cpos = 0
        this.minFontSize = 15
        this.fontSize = 15
        this.inc = 0.24
        this.ang = 5
        this.first = false
        this.init = false

        this.xp = 0
        this.yp = 0
        this.angle = 0

        this.reset = this.reset.bind(this)
        this.setup = this.setup.bind(this)
        this.draw = this.draw.bind(this)
        this.windowResized = this.windowResized.bind(this)
    }

    componentDidMount() {
        this.props.onchangePoemInfo(strings)
    }

    componentWillReceiveProps(props) {
        const { language } = this.props;

        if (props.language !== language) {
            strings.setLanguage(props.language)
            this.reset(this.p5)
        }
    }

    reset(p5) {
        p5.background(0)

        this.fontSize = Math.max(window.innerWidth / 60, this.minFontSize)

        p5.textFont("DejaVuSerif");
        p5.textSize(this.fontSize)

        this.ang = p5.random(2, 8)
        this.first = true
        this.init = false

        this.charsEN = ""
        for (var _ = 1; _ < 100; _++) {
            var pre = extensions.randomChoice(this.englishPrefixes)
            this.charsEN += pre
        }

        this.chars = strings.getLanguage() === "en" ? this.charsEN : this.charsDE
    }

    setup(p5, canvasParentRef) {
        p5.createCanvas(window.innerWidth, window.innerHeight).parent(canvasParentRef)

        this.p5 = p5
        this.reset(p5)
    }

    walk(p5, fwd) {
		for (var _ = 1; _ < fwd; _++) {

			var cpos2 = this.cpos % this.chars.length
			var c = this.chars.substring(cpos2, cpos2+1)
			var tw = p5.textWidth(c)

			if (c === " ") {
				tw = p5.textWidth("x")
            }
			else if (c === "ä") {
				tw = p5.textWidth("a")
            }
			else if (c === "ö") {
				tw = p5.textWidth("o")
            }
			else if (c === "ü") {
				tw = p5.textWidth("u")
            }
			else if (c === "ß") {
				tw = p5.textWidth("b")
			}

            p5.push()
            var xt = tw+0.1*this.fontSize
            p5.translate(this.xp, this.yp)
            p5.rotate(this.angle)
            p5.fill(255, 255, 255, 255)
            p5.text(c, 0, 0)
            p5.pop()

            this.angle += this.ang/(fwd/xt)*Math.PI/180

            this.xp += Math.cos(this.angle)*xt
            this.yp += Math.sin(this.angle)*xt

			this.cpos++
        }
    }

    draw(p5) {
        if (this.first) {
            this.xp = window.innerWidth/2
            this.yp = window.innerHeight/2
            this.angle = 0

            this.fwd = 1
            this.cpos = 0

            this.first = false
            this.init = true
        }
        if (this.init) {
            this.walk(p5, this.fwd)
            this.fwd += this.inc
        }
    }

    windowResized(p5) {
        p5.resizeCanvas(window.innerWidth, window.innerHeight)
        p5.background(0)

        this.reset(p5)
    }

    render() {
        strings.setLanguage(this.context.language)
        return <Sketch setup={this.setup} draw={this.draw} windowResized={this.windowResized} />
    }
}
Spiral.contextType = LanguageContext

export default Spiral
